import { render, staticRenderFns } from "./VpsPendingAppTable.vue?vue&type=template&id=448750b8"
import script from "./VpsPendingAppTable.vue?vue&type=script&lang=js"
export * from "./VpsPendingAppTable.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports